import DateInput from "components/DateInput"
import { classNames } from "utils/dom-helpers"
import {
    TimePicker,
} from '@progress/kendo-react-dateinputs'
import { useState } from "react"

export interface CustomDateCellProps {
    index: number
    start: Date
    custom_date: Date
    base_date: Date
    setCustomDate:(date: Date) => void
    handleDebounce: () => void
    removeCustomDate:() => void
}

export default function CustomDateCell(props: CustomDateCellProps) {
    const {
        index,
        start,
        custom_date,
        base_date,
        setCustomDate,
        handleDebounce,
        removeCustomDate
    } = props
    const [is_date_picker_open, toggleDatePickerOpen] = useState<boolean>(false)

    return (
        <div key={index} className="flex flex-row w-full gap-x-2 text-sm h-9">
            <div className='flex flex-row relative items-center w-[45%]' onClick={() => toggleDatePickerOpen(true)}>
                <DateInput
                    id={index + '_date_input'}
                    minDate={start}
                    className={classNames(
                        'border-0 rounded focus:ring-0 inline-block flex flex-grow h-9',
                    )}
                    onChange={(date: Date) => {
                        handleDebounce()
                        setCustomDate(date)
                    }}
                    dateFormat="dd/MM/yyyy"
                    selected={custom_date}
                    popperClassName="z-20"
                    open={is_date_picker_open}
                    onClickOutside={() => toggleDatePickerOpen(false)}
                />
                <i className='absolute feather-calendar text-xl right-2' />
            </div>
            <TimePicker
                className='flex rounded border-0 items-center w-[45%]'
                min={base_date}
                onChange={(e) => {
                    if (e.target.value && e.value) {
                        handleDebounce()
                        setCustomDate(new Date(e.value.getTime()))
                    }
                }}
                value={custom_date}
            />
            <button
                type="button"
                className={`text-red-500 bg-red-100 h-9 w-9 rounded-lg text-xl feather-trash-2 flex-none`}
                onClick={() => {
                    removeCustomDate()
                }}
            />
        </div>
    )
}